import { useMemo } from "react";
import { useIntl } from "react-intl";

const useHyperlinksByLocale = (): Record<any, string> => {
  const { locale } = useIntl();
  return useMemo(() => {
    const hyperlinks: Record<any, Record<any, string>> = {
      en: {
        CONTACT_URL: "https://kkstream-live.zendesk.com/hc/en-us/requests/new",
        RTMP_URL:
          "https://kkstream-live.zendesk.com/hc/en-us/articles/4405127251737-How-to-live-stream-with-OBS-Studio-",
        FREE_TRIAL_CONTACT_URL: "https://freetrial.blendvision.events/contact-us",
        SUPPORT_URL: "https://kkstream-live.zendesk.com/hc/en-us",
        LEARN_MORE_URL: "https://kkstream-live.zendesk.com/hc/en-us/articles/900002947426-Create-a-live-event",
        LOOM_ACCOUNT_REGISTRATION_URL:
          "https://kkstream-blendvision.zendesk.com/hc/en-us/articles/900003147443-Account-Registration-Login",
        LOOM_BEFORE_YOU_START_URL:
          "https://kkstream-blendvision.zendesk.com/hc/en-us/articles/900004060426-Before-You-Start",
        LOOM_CHECK_ENCODING_STATUAS_URL:
          "https://kkstream-blendvision.zendesk.com/hc/en-us/articles/900003729446-Check-Your-Encoding-Status",
      },
      zh: {
        CONTACT_URL: "https://kkstream-live.zendesk.com/hc/zh-tw/requests/new",
        RTMP_URL:
          "https://kkstream-live.zendesk.com/hc/zh-tw/articles/4405127251737-OBS-%E7%9B%B4%E6%92%AD%E6%95%99%E5%AD%B8-",
        FREE_TRIAL_CONTACT_URL: "https://freetrial.blendvision.events/contact-us",
        SUPPORT_URL: "https://kkstream-live.zendesk.com/hc/zh-tw",
        LEARN_MORE_URL:
          "https://kkstream-live.zendesk.com/hc/zh-tw/articles/900002947426-%E5%BB%BA%E7%AB%8B%E7%9B%B4%E6%92%AD%E6%B4%BB%E5%8B%95",
        LOOM_ACCOUNT_REGISTRATION_URL:
          "https://kkstream-blendvision.zendesk.com/hc/en-us/articles/900003147443-Account-Registration-Login",
        LOOM_BEFORE_YOU_START_URL:
          "https://kkstream-blendvision.zendesk.com/hc/en-us/articles/900004060426-Before-You-Start",
        LOOM_CHECK_ENCODING_STATUAS_URL:
          "https://kkstream-blendvision.zendesk.com/hc/en-us/articles/900003729446-Check-Your-Encoding-Status",
      },
      ja: {
        CONTACT_URL: "https://kkstream-live.zendesk.com/hc/ja/requests/new",
        RTMP_URL:
          "https://kkstream-live.zendesk.com/hc/en-us/articles/4405127251737-How-to-live-stream-with-OBS-Studio-",
        FREE_TRIAL_CONTACT_URL: "https://freetrial.blendvision.events/contact-us/jp",
        SUPPORT_URL: "https://kkstream-live.zendesk.com/hc/ja",
        LEARN_MORE_URL:
          "https://kkstream-live.zendesk.com/hc/ja/articles/900002947426-%E3%83%A9%E3%82%A4%E3%83%96%E3%82%A4%E3%83%99%E3%83%B3%E3%83%88%E3%81%AE%E4%BD%9C%E6%88%90",
        LOOM_ACCOUNT_REGISTRATION_URL:
          "https://kkstream-blendvision.zendesk.com/hc/en-us/articles/900003147443-Account-Registration-Login",
        LOOM_BEFORE_YOU_START_URL:
          "https://kkstream-blendvision.zendesk.com/hc/en-us/articles/900004060426-Before-You-Start",
        LOOM_CHECK_ENCODING_STATUAS_URL:
          "https://kkstream-blendvision.zendesk.com/hc/en-us/articles/900003729446-Check-Your-Encoding-Status",
      },
    };

    return hyperlinks[locale] ?? hyperlinks.en;
  }, [locale]);
};

export default useHyperlinksByLocale;
